<div mat-dialog-title>
    {{'Language proficiency'| translate}}
    <span class="float-right pointer" (click)="close()">
      <i class="fa fa-times close-btn "></i>
    </span>
    <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->
  
  
  </div>
  <div mat-dialog-content class="">
    <form [formGroup]="languageForm">
      <div class="row">
        <div class="col-md-3">
          <tm-select [form_group]="languageForm" (selected_obj)="languageChanged($event)" [form_control]="'languageId'"
            [options]="masters.lngMasterList" [data]="languageForm.value.languageId" [label]="'Language'"
            [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
        <div class="col-md-1">
          <tm-select [form_group]="languageForm" [form_control]="'speakId'" [options]="masters.srwMasterList"
            [data]="languageForm.value.speakId" [label]="'Speak'" [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
        <div class="col-md-1">
          <tm-select [form_group]="languageForm" [form_control]="'readId'" [options]="masters.srwMasterList"
            [data]="languageForm.value.readId" [label]="'Read'" [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
        <div class="col-md-1">
          <tm-select [form_group]="languageForm" [form_control]="'writeId'" [options]="masters.srwMasterList"
            [data]="languageForm.value.writeId" [label]="'Write'" [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
        <div class="col-md-2">
          <tm-select [form_group]="languageForm" [form_control]="'certifiedId'"
            *ngIf="this.certifiedTypeList && this.certifiedTypeList.length" [options]="this.certifiedTypeList "
            (selected_obj)="certifiedChanged($event)" [data]="languageForm.value.certifiedId" [label]="'Certified'"
            [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
  
        <div class="col-md-1">
          <tm-select [form_group]="languageForm" *ngIf="scoreMasterList && scoreMasterList.length"
            [form_control]="'score'" [options]="scoreMasterList " [data]="languageForm.value.score" [label]="'Score'"
            [placeholder]="'<--Select-->'">
          </tm-select>
        </div>
        <div class="col-md-2">
          <tm-files-v2 [form_group]="languageForm" [form_control]="'attachment'" [label]="'Certificate'"
            [result]="languageForm.value.attachment">
          </tm-files-v2>
        </div>
        <div class="col-md-1 ">
          <button class="btn btn-sm js-btn-save" (click)="addLanguage()"> <i class="fa fa-plus-square"></i> Add</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive  ">
          <table class="table table-stripped">
            <thead>
              <tr>
                <th>Language</th>
                <th>Speak</th>
                <th>Read</th>
                <th>Write</th>
                <th>Certified</th>
                <th class="text-right" t>Score</th>
                <th>Certificate</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of language_list;let i=index">
                <td> {{item.languageId | DynamicPipe : masters.lngMasterList : 'id':'title'}} </td>
                <td> {{item.speakId | DynamicPipe : masters.srwMasterList : 'id':'title'}} </td>
                <td> {{item.readId | DynamicPipe : masters.srwMasterList : 'id':'title'}} </td>
                <td> {{item.writeId | DynamicPipe : masters.srwMasterList : 'id':'title'}} </td>
  
                <td> {{item.certifiedId | DynamicPipe : masters.certifiedTypeList : 'id':'title'}} </td>
                <td class="text-right"> {{item.score | DynamicPipe : masters.scoreMasterList : 'id':'title'}} </td>
                <td class="link" (click)="viewAttachments(item.attachment)"> {{item.attachment | DynamicFilesTitlePipe }}
                </td>
                <td class="text-center">
                  <span class='btn btn-sm btn-default mr-1' (click)="editEducation(item,i)">
                    <i class="fa fa-pencil mx-1"></i> Edit
                  </span>
                  <span class='btn btn-sm btn-default ' (click)="deleteEducation(item)">
                    <i class="fa fa-trash orage mx-1"></i> Delete
                  </span>
  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
    </form>
  
  </div>
  <mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>
  
    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn-sm btn mx-1 mx-1 tallite-action"
      (click)="close()">
      {{ 'BTN.cancel' | translate}}
      <span class="blob-btn-cancel__inner">
        <span class="blob-btn-cancel__blobs">
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
          <span class="blob-btn-cancel__blob"></span>
        </span>
      </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn  btn-sm  mx-1 tallite-action" type="submit" (click)="save()">
      {{ 'BTN.ok' | translate }}
      <span class="blob-btn__inner">
        <span class="blob-btn__blobs">
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
          <span class="blob-btn__blob"></span>
        </span>
      </span>
    </button>
  </mat-dialog-actions>